import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";

const LINKS = [
  { to: "/", label: "Home" },
  { to: "/sports", label: "Sports" },
  { to: "/music", label: "Music" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [location.pathname]);

  const goContact = () => {
    setOpen(false);
    const el = document.getElementById("contact");
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate("/");
      setTimeout(() => document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" }), 400);
    }
  };

  const linkClass = ({ isActive }) =>
    `rc-navlink font-display text-sm font-medium uppercase tracking-widest transition-colors ${
      isActive ? "rc-navlink--active text-[#BAF173]" : "text-white/70 hover:text-white"
    }`;

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled ? "backdrop-blur-xl bg-black/70 border-b border-white/10" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 md:px-12 h-16 md:h-20 flex items-center justify-between">
        <Link to="/" data-testid="logo-home" className="flex items-center gap-2.5 group">
          <img
            src="https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/sbsj2wrh_Icono%20Blanco.png"
            alt="REYCRO"
            className="h-8 md:h-9 w-auto transition-transform duration-300 group-hover:scale-110"
          />
          <img
            src="https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/1z3p6ihh_Variacio%CC%81n%20B.png"
            alt="REYCRO"
            className="h-5 md:h-6 w-auto"
          />
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {LINKS.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.to === "/"} data-testid={`nav-${n.label.toLowerCase()}`} className={linkClass}>
              {n.label}
            </NavLink>
          ))}
          <button
            data-testid="nav-partner-cta"
            onClick={goContact}
            className="font-display text-sm font-semibold uppercase tracking-widest px-5 py-2.5 bg-[#BAF173] text-black hover:bg-[#a5db65] transition-colors"
          >
            Work With Me
          </button>
        </nav>

        <button
          data-testid="mobile-menu-toggle"
          className="lg:hidden text-white"
          onClick={() => setOpen(!open)}
        >
          {open ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-black/95 border-t border-white/10 px-6 py-6 flex flex-col gap-4">
          {LINKS.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.to === "/"}
              data-testid={`mobile-nav-${n.label.toLowerCase()}`}
              className={({ isActive }) =>
                `font-display text-left text-lg uppercase tracking-widest ${isActive ? "text-[#BAF173]" : "text-white/80 hover:text-[#BAF173]"}`
              }
            >
              {n.label}
            </NavLink>
          ))}
          <button
            data-testid="mobile-nav-cta"
            onClick={goContact}
            className="font-display mt-2 text-center text-sm font-semibold uppercase tracking-widest px-5 py-3 bg-[#BAF173] text-black"
          >
            Work With Me
          </button>
        </div>
      )}
    </header>
  );
};
